export default __webpack_public_path__ + "static/PPNeueMontreal-SemiBold-11ce7260119bd987ca5a92a82ed3d6f4.woff";